export const FORECAST_TBL_HEAD = [
  {
    field: 'course_enrollment_id',
    headerName: 'Enrollment ID',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 180,
    sortable: true,
  },
  {
    field: 'current_class',
    headerName: 'Class',
    width: 180,
    sortable: true,
  },
  {
    field: 'oga_name',
    headerName: 'OGA Name',
    width: 160,
    sortable: true,
  },
  {
    field: 'cro_name',
    headerName: 'CRO Name',
    width: 160,
    sortable: true,
  },
  {
    field: 'project_name',
    headerName: 'Project',
    width: 160,
    sortable: true,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    sortable: true,
  },
  {
    field: 'student_country_code',
    headerName: 'Country Code',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'student_mob_no',
    headerName: 'Mobile No',
    width: 150,
    sortable: true,
  },
  {
    field: 'forcast_calculated_method',
    headerName: 'Forecast Method',
    width: 180,
    sortable: true,
  },
  {
    field: 'term_options_inr',
    headerName: 'Term Options Inr',
    width: 180,
    sortable: true,
    valueGetter: (params) => params.row.term_options_inr?.join(', ') || '',
  },
  {
    field: 'term_options_aed',
    headerName: 'Term Options Aed',
    width: 180,
    sortable: true,
    valueGetter: (params) => params.row.term_options_aed?.join(', ') || '',
  },
  {
    // Currency-resolved term schedule: for currency 3 (AEDTOINR) this is term_options_aed
    // converted to INR, not the raw term_options_inr column (which is an independently-priced
    // track on the same course_options row and doesn't reflect what's actually forecast).
    field: 'term_options_actual',
    headerName: 'Term Options (Actual)',
    width: 180,
    sortable: true,
    valueGetter: (params) => params.row.term_options_actual?.join(', ') || '',
  },
  {
    field: 'percentage_options',
    headerName: 'Percentage Options',
    width: 180,
    sortable: true,
    valueGetter: (params) => params.row.percentage_options?.join(', ') || '',
  },
  {
    field: 'forcast_calculated_method',
    headerName: 'Forecast Method',
    width: 180,
    sortable: true,
  },
  {
    field: 'cart_item_selected_option_currency',
    headerName: 'Currency Type',
    width: 180,
    sortable: true,
    valueGetter: (params) =>
      params.row.cart_item_selected_option_currency == 1
        ? 'INR'
        : params.row.cart_item_selected_option_currency == 2
          ? 'AED'
          : 'AED to INR',
  },
  {
    field: 'cart_item_mrp',
    headerName: 'MRP',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'cart_item_discount',
    headerName: 'Discount',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'sale_amount',
    headerName: 'Sale Amount',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
    valueGetter: (params) => params.row.cart_item_mrp - params.row.cart_item_discount,
  },
  {
    field: 'expected_sessions',
    headerName: 'Expected Sessions',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'amount_to_collect',
    headerName: 'Amount To Collect',
    width: 160,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'amount_collected_this_month',
    headerName: 'Collected This Month',
    width: 180,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'amount_pending',
    headerName: 'Pending Amount',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'carry_forward_amount',
    headerName: 'Carry Forward',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'final_amount_to_collect',
    headerName: 'Final Amount',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'month',
    headerName: 'Month',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'year',
    headerName: 'Year',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'is_retention',
    headerName: 'Retention',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
    valueGetter: (params) => (params.row.is_retention == 1 ? 'Yes' : 'No'),
  },
];
